import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';

const DayToExpaire = ({...props}) =>{
 console.log(props)
    var exam_id = (props && props.record)? props.record.exam_id :  null;
    var user_id = (props && props.record)? props.record.user_id :  null;

    const { data, loading, error } = useQuery({ 
        type: 'getMany',
        resource: 'daytoexpire',
        payload:  {ids: [ exam_id, user_id]}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
  console.log(data)
    return (
            <div >{
                (data && data[0].days_due < 0 ) ? <font color="red"><b>Overdue</b></font> 
                : (data && data[0].days_due < 7 ) ? <font color="orange"><b>{data[0].days_due}</b></font> 
                : <font color="green">{data[0].days_due}</font> }
            </div>
        
    )
}
export default DayToExpaire